import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1332996085607751';
/**
 * Meta Pixel base code (official Meta snippet), injected once as early as
 * possible on load. Inserts the <script> into <head> and the <noscript>
 * fallback into <body>. PageView fires automatically from the base code.
 *
 * NOTE: Magic Patterns has no editable index.html <head>, so the exact
 * official snippet is injected at runtime instead — pixel ID and script
 * structure are kept verbatim.
 */
export function MetaPixel() {
  useEffect(() => {
    // Guard: ensure it only ever runs / injects once per page session.
    if (typeof window === 'undefined') return;
    if ((window as any).__metaPixelInjected) return;
    (window as any).__metaPixelInjected = true;
    // --- Meta Pixel Code (script) ---
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`;
    document.head.appendChild(script);
    // --- Meta Pixel Code (noscript fallback) ---
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return null;
}